import { TextDivider, type TextDividerProps } from '@talos/kyoko';

interface TextDividerSimpleProps {
  text: string;
}

const TEXT_DIVIDER_SIMPLE_PROPS = {
  textProps: {
    color: 'colors.gray.080',
    fontSize: 'fontSizeSm',
    weight: 'fontWeightNormal',
  },
  dividerProps: { color: 'colors.gray.000' },
} as const satisfies Omit<TextDividerProps, 'text'>;

/**
 * A lightweight version of TextDivider with subdued styling.
 * Uses lighter colors, smaller font size, and normal weight for a more subtle appearance.
 */
export function TextDividerSimple({ text }: TextDividerSimpleProps) {
  return <TextDivider text={text} {...TEXT_DIVIDER_SIMPLE_PROPS} />;
}
